import { formFields } from './formFields';
import { IntlShape } from 'react-intl';
import { Shape } from 'app/features/shapeValidation/slice/types';
import { ShapeField } from 'types';

export const formConfig: (
  shapeName: Shape,
  intl: IntlShape,
) => ShapeField[][] = (shape, intl) => {
  const result = formFields(intl)
    .filter(form => form.name === shape)[0]
    .fields.reduce(
      (fields, item) => ({
        ...fields,
        [item.section]: [...(fields[item.section] || []), item],
      }),
      {},
    );

  return result && Object.values(result);
};
